import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../../../utils";
import FilterDropdown from "../../FilterDropdown";
import FilterDropdownTextItem from "../../FilterDropdownTextItem";
import PageSelectControl from "../../PageSelectControl";
import styles from "./TableHeader.module.css";
import { getCustomPageRowsNumbers } from "../../../utils/pagination";
const TableHeader = (props) => {
    const { disableRowNumberCtrl = false, selectedRenderLimit, setRenderLimit, dataLength, currentPage, setCurrentPage, pagination, pageSetEvent, className, setPagination, rowLimitFromPaginationHook, currentPageFromPaginationHook, } = props;
    const pageRows = getCustomPageRowsNumbers(dataLength);
    const setCurrentPageHandler = (newPage, eventType) => {
        setCurrentPage === null || setCurrentPage === void 0 ? void 0 : setCurrentPage(newPage);
        if (pagination) {
            pagination(newPage);
        }
        if (pageSetEvent) {
            pageSetEvent(currentPage, newPage, eventType);
        }
        setPagination === null || setPagination === void 0 ? void 0 : setPagination(newPage, rowLimitFromPaginationHook);
    };
    const filterDropdownTextItems = pageRows.map((number) => (_jsx(FilterDropdownTextItem, { title: number, onClick: () => {
            setRenderLimit(number);
            setPagination === null || setPagination === void 0 ? void 0 : setPagination(1, number);
        }, className: styles.rowLimitDropdown, closeOnClick: true }, void 0)));
    return (_jsxs("div", Object.assign({ className: classNames(styles.rowLimitControl, className) }, { children: [!disableRowNumberCtrl && (_jsxs(_Fragment, { children: ["Show Rows", _jsx("div", Object.assign({ className: styles.rowLimitDropdownContainer }, { children: _jsx(FilterDropdown, Object.assign({ title: rowLimitFromPaginationHook
                                ? rowLimitFromPaginationHook
                                : selectedRenderLimit, variant: "select", size: "tiny", className: styles.rowLimitDropdown }, { children: filterDropdownTextItems }), void 0) }), void 0)] }, void 0)), _jsx(PageSelectControl, { hidePageNumbers: true, pageCount: rowLimitFromPaginationHook
                    ? Math.ceil(dataLength / rowLimitFromPaginationHook)
                    : Math.ceil(dataLength / selectedRenderLimit), currentPage: currentPageFromPaginationHook
                    ? currentPageFromPaginationHook
                    : currentPage, setCurrentPage: (newPage, eventType) => {
                    setCurrentPageHandler(newPage, eventType);
                } }, void 0)] }), void 0));
};
export default TableHeader;
